import React, { useState } from 'react';
import api from '@/auth/api';
import { alertSuccess, alertError } from '@/components/Alert';


const AddForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    title:"",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await api.post("/redeem/panel/SubCategory", formData);
      alertSuccess("Agency added successfully!");
      if (onSuccess) {
        onSuccess();
      }
      setFormData({
        title: '',
      });
  
    } catch (error) {
      alertError(error?.response?.data?.errors || "Something went wrong.");
    }
  };
  

  const handleChange = ({ target: { name, value } }) =>
    setFormData(prev => ({ ...prev, [name]: value }));


  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto bg-white p-3 rounded text-sm space-y-3">
      <div>
        <input type="text" name="title" value={formData.title} onChange={handleChange} required className="w-full border px-2 py-1 rounded" placeholder='Enter agency category' />
      </div>

      <button type="submit" className="w-full bg-blue-600 text-white py-1 rounded hover:bg-blue-700">
        Submit
      </button>
    </form>
  );
};

export default AddForm;
